import { useState } from 'react';
import { makeAuthenticatedRequest } from '../utils/apiHelpers';
import { isDraftItem } from '../utils/helpers';

const API_URL = process.env.REACT_APP_API_URL;

const useProjectNameEdit = ({ token, setGenerations, setBulkGenerations }) => {
  const [editingProjectName, setEditingProjectName] = useState(null);
  const [newProjectName, setNewProjectName] = useState('');
  const [editingBulkProjectName, setEditingBulkProjectName] = useState(null);
  const [newBulkProjectName, setNewBulkProjectName] = useState('');
  const [isUpdatingBulkProjectName, setIsUpdatingBulkProjectName] = useState(false);

  // Shared save logic for both single and bulk
  const saveProjectName = async (id, name, { setList, setEditing, setName, setUpdating }) => {
    if (!name.trim()) return;
    if (setUpdating) setUpdating(true);
    try {
      const response = await makeAuthenticatedRequest(
        `${API_URL}/auth/listings/update-content`, token,
        { method: 'post', data: { id, original: { project_name: '' }, updated: { project_name: name.trim() } } }
      );
      if (response.data.success) {
        const trimmedName = name.trim();
        setList(prev => prev.map(gen => {
          if (gen._id !== id) return gen;
          return {
            ...gen,
            project_name: trimmedName,
            ...(isDraftItem(gen) ? { draft_name: trimmedName } : {}),
            product: { ...gen.product, project_name: trimmedName }
          };
        }));
        setEditing(null);
        setName('');
      }
    } catch (error) {
    } finally {
      if (setUpdating) setUpdating(false);
    }
  };

  const handleSaveProjectName = (generationId) =>
    saveProjectName(generationId, newProjectName, {
      setList: setGenerations, setEditing: setEditingProjectName, setName: setNewProjectName
    });

  const handleSaveBulkProjectName = (bulkProjectId) =>
    saveProjectName(bulkProjectId, newBulkProjectName, {
      setList: setBulkGenerations, setEditing: setEditingBulkProjectName,
      setName: setNewBulkProjectName, setUpdating: setIsUpdatingBulkProjectName
    });

  const cancelEdit = (setEditing, setName) => { setEditing(null); setName(''); };
  const handleCancelEdit = () => cancelEdit(setEditingProjectName, setNewProjectName);
  const handleCancelBulkProjectNameEdit = () => cancelEdit(setEditingBulkProjectName, setNewBulkProjectName);

  return {
    editingProjectName, setEditingProjectName, newProjectName, setNewProjectName,
    editingBulkProjectName, setEditingBulkProjectName, newBulkProjectName, setNewBulkProjectName,
    isUpdatingBulkProjectName,
    handleSaveProjectName, handleSaveBulkProjectName,
    handleCancelEdit, handleCancelBulkProjectNameEdit,
  };
};

export default useProjectNameEdit;
